module.exports = __webpack_public_path__ + "static/media/studio2-2.3036b2a9.png";